export class RewardHistory{
  constructor(rewardHistory) {
    this.id = rewardHistory.id,
    this.customer_id = rewardHistory.customer_id,
    this.redeem_id = rewardHistory.redeem_id,
    this.current_point = rewardHistory.current_point ,
    this.changed_point = rewardHistory.changed_point,
    this.lasted_point = rewardHistory.lasted_point,
    this.description = rewardHistory.description,
    this.created_at = rewardHistory.created_at,
    this.checkout_id = rewardHistory.checkout_id,
    this.checkin_id = rewardHistory.checkin_id,
    this.customer_name = rewardHistory.customer_name,
    this.customer_phone = rewardHistory.customer_phone,
    this.redeem_content = rewardHistory.redeem_content,
    this.staff_name = rewardHistory.staff_name,
    this.total_price = rewardHistory.total_price,
    this.discount = rewardHistory.discount
  }
}
